import { Stack, Typography } from "@mui/material";
import { TimeField } from "@mui/x-date-pickers-pro";
import { addHours, getHours, isValid, startOfToday } from "date-fns";

interface Props {
  hour?: number;
  readonly: boolean;
  onHourChange: (hour?: number) => void;
  validationError?: string;
}

const DataBackupConfigurationTimeSettings = ({ hour, onHourChange, readonly, validationError }: Props) => {
  const handleChange = (newValue: Date | null) => {
    const newHour = newValue && isValid(newValue) ? getHours(newValue) : undefined;
    if (newHour !== hour) {
      onHourChange(newHour);
    }
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="subtitle2">Settings</Typography>
        <Typography color="secondary">
          Set the time for the daily backup. The selected time is displayed in your local timezone.
        </Typography>
      </Stack>
      <TimeField
        value={hour !== undefined ? addHours(startOfToday(), hour) : null}
        onChange={handleChange}
        disabled={readonly}
        sx={{ maxWidth: "6rem" }}
        slotProps={{
          textField: {
            error: !!validationError,
          },
        }}
      />
    </Stack>
  );
};

export default DataBackupConfigurationTimeSettings;
